import { LD_FLAG_IDEA_MDP_575 } from "./launchDarklyFlagKeys";

/** LaunchDarkly gate for the account Tasks module (sidebar, /tasks, Your Stuff > Your Tasks). */
export const TASKS_MODULE_LD_FLAG = LD_FLAG_IDEA_MDP_575;

/** User-facing label for the top-level /tasks page and matching sidebar item (not "Your Tasks"). */
export const ALL_TASKS_LABEL = "All Tasks";

/** Assignee filter on All Tasks (`/tasks`) — not used on Your Stuff > Your Tasks. */
export const MY_TASKS_FILTER_LABEL = "My Tasks";
export const TASKS_ASSIGNEE_FILTER_GROUP = "Assignee";
export const MY_TASKS_FILTER_VALUE = "my_tasks";
/** Default assignee scope on All Tasks — selected in the filter modal, not shown as a chip. */
export const ALL_TASKS_ASSIGNEE_FILTER_VALUE = "all_assignees";

export function isMyTasksAssigneeFilter(filter) {
  const key = String(filter || "")
    .toLowerCase()
    .replace(/\s+/g, "_");
  return key === MY_TASKS_FILTER_VALUE;
}
